/**
 * Socket bookkeeping shared by the Claude Code and Codex / OpenCode docks.
 *
 * Every event a dock session sends carries a per-SESSION `seq`, and the hooks
 * drop anything at or below the highest one they have applied (replays after a
 * reconnect are not shown twice). A new session starts counting at 1 again —
 * an idle session expires after a while, and the next message joins a fresh
 * one — so carrying the old high-water mark across dropped EVERY event of the
 * new run: no text, no `complete`, and a spinner that never stopped.
 */

/** Keep-alive interval: an open dock is activity, so a session waiting on the
 *  user's answer to a question is not retired by the idle TTL. */
export const DOCK_PING_MS = 60_000

/** The seq to resume from when (re)connecting to `sid`: the high-water mark
 *  only applies to the session it was counted on. */
export function afterSeqFor(connectedSid: string | null, sid: string, lastSeq: number): number {
  return connectedSid === sid ? lastSeq : 0
}

/** A refused send (a run already going, another plan holding the project)
 *  never started: drop the empty assistant bubble the send put up for it. */
export function unwindRefusedTurn<M extends { role: string; content: string }>(messages: M[]): M[] {
  const last = messages[messages.length - 1]
  if (last && last.role === 'assistant' && !(last.content || '').trim()) {
    return messages.slice(0, -1)
  }
  return messages
}
